import { Space } from 'antd';
import { startCase } from 'lodash';
import React, { FC } from 'react';
import { format } from 'components/organisms/tasks/criteria/estimate/format';
import { EstimateFieldFilter } from 'components/organisms/tasks/filters/estimate';

export const EstimateFilterToText: FC<{ filter: EstimateFieldFilter }> = ({
  filter,
}) => {
  const {
    field: { fieldLabel },
  } = filter;

  return (
    <Space size={4}>
      <span>{startCase(fieldLabel)}</span>
      <span>{format(filter)}</span>
    </Space>
  );
};
